import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import Annotation from "~/components/build/Show/components/Annotation";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { allBuildAnnotationsQueryOptions } from "~/components/build/Show/lib/queries/allBuildAnnotations";
import { BuildAnnotationsEmptyState } from "~/components/build/Show/components/AnnotationsEmptyState";
import { useReactRouterNavigateHandler } from "~/components/build/Show/lib/useReactRouterNavigateHandler";
import Spinner from "~/components/shared/Spinner";

export default function BuildAnnotations() {
  const { build } = useBuild();
  const navigateClickHandler = useReactRouterNavigateHandler();

  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useInfiniteQuery(
    allBuildAnnotationsQueryOptions(build, {
      placeholderData: keepPreviousData,
    }),
  );

  const handleShowMore = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  const paginatedAnnotations = useMemo(() => {
    return (data?.pages || []).flatMap((page) => page.records);
  }, [data?.pages]);

  if (isLoading) {
    return (
      <div className="flex w-full items-center space-x-2">
        <Spinner className="h-4 w-4" />
        <span>Fetching annotations...</span>
      </div>
    );
  }

  const noAnnotations = paginatedAnnotations.length === 0;
  if (noAnnotations) {
    return <BuildAnnotationsEmptyState />;
  }

  return (
    <div className="flex w-full flex-1 flex-col" onClick={navigateClickHandler}>
      {paginatedAnnotations.map((annotation) => (
        <Annotation key={annotation.id} annotation={annotation} />
      ))}

      {hasNextPage && (
        <div className="flex w-full items-center justify-center">
          {isFetchingNextPage ? (
            <div className="space-x-2">
              <Spinner className="h-4 w-4" />
              <span>Fetching annotations...</span>
            </div>
          ) : (
            <button className="btn btn-small btn-depth" onClick={handleShowMore}>
              Show more
            </button>
          )}
        </div>
      )}
    </div>
  );
}
